import { CardAction } from "components/Card/cardAction";
import { match, P } from "ts-pattern";
import { PageBuilderCardMosaicItemFragment } from "types/graphql-types";
import PageBuilderButtonCTA from "../PageBuilderButtonCTA";
import React from "react";
import { ButtonVariant } from "@silversea-ssc/ui-components-react";
import { buildFycLinkCTAUrl } from "../fyc/buildFycLinkCTAButtonUrl";
import { toButtonVariantProps } from "../buttons";
import { Language } from "src/utils/localization/languages/types";

type CardCTAButton =
  | NonNullable<PageBuilderCardMosaicItemFragment["ctaButtons"]>[0]
  | {
      __typename: "Button";
      onClick: () => void;
      variant: ButtonVariant | undefined;
    };

export const cardCTAButtonToCardAction =
  (onClickAnchor: (section: string | undefined) => void, language: Language) =>
  (ctaButton: CardCTAButton | undefined): CardAction | undefined => {
    if (!ctaButton) return undefined;

    return match(ctaButton)
      .returnType<CardAction | undefined>()
      .with(P.nullish, () => undefined)
      .with({ __typename: "SanityLinkCTA" }, (props) => ({
        href: props.url?.localized,
        linkLabel: props.label?.localized,
        openInNewTab: props.openInNewTab,
        ...toButtonVariantProps(props.variant)
      }))
      .with({ __typename: "SanityFycLinkCTA" }, (props) => ({
        href: buildFycLinkCTAUrl(props, language),
        linkLabel: props.label?.localized,
        ...toButtonVariantProps(props.variant)
      }))
      .with({ __typename: "SanityPageCTA" }, (props) => ({
        href: props.page?.fullPath,
        openInNewTab: props.openInNewTab,
        linkLabel: props.label?.localized,
        ...toButtonVariantProps(props.variant)
      }))
      .with({ __typename: "Button" }, (props) => ({
        onClick: props?.onClick,
        variant: props.variant
      }))
      .with({ __typename: "SanityAnchorCTA" }, (props) => ({
        onClick: () => onClickAnchor(props.target),
        linkLabel: props.label?.localized,
        ...toButtonVariantProps(props.variant)
      }))

      .otherwise((props) => ({
        button: (
          <PageBuilderButtonCTA
            {...props}
            variant="link"
            defaultButtonVariant="text"
          />
        )
      }));
  };
